import request from '@/utils/Request'

export type Brand = {
  id: number
  name: string,
  brand_initial: string,
  name_division: string
}

export type BrandsResponse = {
  brands: Brand[]
}

export async function getBrands() {
  return await request.get<BrandsResponse>('/favorite-store/brands');
}

export async function getPrefectures(brandId: string) {
  return await request.get<BrandsResponse>(`/favorite-store/prefectures/${brandId}`);
}

export async function getStores(brandId: string, prefectureId: string) {
  return await request.get<BrandsResponse>(`/favorite-store/stores/${brandId}/${prefectureId}`);
}

export async function getStoreByCode(storeCode: string) {
  return await request.get<BrandsResponse>(`/favorite-store/store/code/${storeCode}`);
}